import { jwtAxiosInst } from "@thingsw/pitta-modules";

interface ICloudStorageUsage {
  devName: string;
  limit: number;
  psn: string;
  regCategory: string;
  usage: number;
}

export const getCloudStorageUsage = async (email: string) => {
  const res = await jwtAxiosInst.get<{ response: ICloudStorageUsage[] }>(
    `/cloudStorage/usage-account?email=${email}`
  );

  return res.data.response;
};
